import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert, Container } from '@mui/material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function AnonViewer() {
  const { token } = useParams();
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setError('Invalid viewer link.'); return; }

    axios.get(`${API_URL}/api/secure-viewer/anon/${token}`)
      .then((res) => {
        if (res.data.success && res.data.viewerUrl) {
          window.location.href = res.data.viewerUrl;
        } else {
          setError('Unable to load viewer. The link may have expired.');
        }
      })
      .catch((err) => {
        setError(err.response?.data?.error || 'This link is invalid or has expired.');
      });
  }, [token]);

  return (
    <Container maxWidth="sm" sx={{ mt: 10, textAlign: 'center' }}>
      {error ? (
        <Alert severity="error" sx={{ textAlign: 'left' }}>{error}</Alert>
      ) : (
        <Box>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography variant="body1" color="textSecondary">
            Loading anonymized viewer…
          </Typography>
        </Box>
      )}
    </Container>
  );
}
